import styled from 'styled-components';
import { fonts } from 'ui/theme';

import { Header, LookupForm } from './components';
import { FormContextProvider } from './contexts/FormContextProvider';
import { UserKeyLookupQueryContextProvider } from './contexts/UserKeyLookupQueryContextProvider';

const Wrapper = styled.div`
  ${fonts.sansSerif}
`;

export const ContactLookupPage = () => (
  <UserKeyLookupQueryContextProvider>
    <FormContextProvider>
      <Wrapper data-test="contact-lookup-page">
        <Header />
        <LookupForm />
      </Wrapper>
    </FormContextProvider>
  </UserKeyLookupQueryContextProvider>
);
